import { PayloadAction } from '@reduxjs/toolkit';

import { setNumberValue } from '../../logic/value';
import { buildLineItem } from '../builders/line-item';
import { buildQuantityBreak } from '../builders/quantity-break';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineUuid: string;
  priceUuid: string;
};

export function addQuoteLine(
  state: WritableAutoConfiguratorState,
  { payload: { lineUuid, priceUuid } }: PayloadAction<Payload>,
) {
  const lineItem = buildLineItem({ uuid: lineUuid, isPending: true });

  setNumberValue(lineItem.lineNumber, state.lineItemUuids.length + 1);

  const quantityBreak = buildQuantityBreak({
    lineItemUuid: lineItem.uuid,
    uuid: priceUuid,
    isPending: true,
  });

  lineItem.quantityBreakUuids.push(quantityBreak.uuid);

  state.lineItemUuids.push(lineItem.uuid);
  state.lineItems[lineItem.uuid] = lineItem;
  state.quantityBreaks[quantityBreak.uuid] = quantityBreak;
}
